// A Search's job description, for candidates — T512 (28 Oct 2026).
//
// Made by the Search page's button (`make`, which writes one only when the Search has changed) or
// by the brain's agent (`job_description`), and kept by the brain API as made; in the brain's chat it
// comes under her answer to save (ChatDownloads.tsx, `pdf`). The bytes come behind the login, so the
// page fetches them with its token and saves them itself, as the Profile PDF button does.
import { API_PREFIX, type RequestFn } from './core.ts';

export const jobDescriptionsApi = (request: RequestFn) => ({
  make: (searchId: string) =>
    request<ArrayBuffer>(`${API_PREFIX}/searches/${searchId}/job-description.pdf`, {
      method: 'POST',
      binary: true,
    }),
  pdf: (jobDescriptionId: string) =>
    request<ArrayBuffer>(`${API_PREFIX}/job-descriptions/${jobDescriptionId}/pdf`, {
      binary: true,
    }),
});
